(function () {
  const drawer = document.getElementById("cartDrawer");
  if (!drawer) return;

  const itemsEl = document.getElementById("cartDrawerItems");
  const emptyEl = document.getElementById("cartDrawerEmpty");
  const footEl = document.getElementById("cartDrawerFoot");
  const subtotalEl = document.getElementById("cartDrawerSubtotal");
  const countEl = document.getElementById("cartDrawerCount");
  const headerCount = document.querySelector(".cart-count");
  const upsellEl = document.getElementById("cartUpsell");
  const upsellAddBtn = document.getElementById("cartUpsellAdd");

  // Drop a trailing .00 so cart figures match the product page ($87, not $87.00);
  // real cents are still shown ($14.50).
  const fmt = (cents) => {
    const v = cents / 100;
    return "$" + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };
  const cap = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s);
  // "Velora Buy 3 Get 5 Free" -> "BUY 3 GET 5 FREE"
  const cleanTag = (title) =>
    (title || "").replace(/^velora\s+/i, "").toUpperCase();
  const TAG_SVG =
    '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
  const TRASH_SVG =
    '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>';

  // Блокировка прокрутки: overflow ставим на <html>, а не на <body>.
  // У <body> он не сработает — корень идёт с overflow-x: clip, и проброс
  // на вьюпорт отключается. На <html> позиция страницы сохраняется сама,
  // без position:fixed и без ручного восстановления.
  let prevRootOverflow = "";

  function lockScroll() {
    prevRootOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = "hidden";
  }

  function unlockScroll() {
    document.documentElement.style.overflow = prevRootOverflow;
  }

  function open() {
    if (drawer.classList.contains("is-open")) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    lockScroll();
    refresh();
  }

  function close() {
    if (!drawer.classList.contains("is-open")) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    unlockScroll();
  }

  drawer
    .querySelectorAll("[data-cart-close]")
    .forEach((el) => el.addEventListener("click", close));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") close();
  });

  async function refresh() {
    try {
      const res = await fetch("/cart.js", {
        headers: { Accept: "application/json" },
      });
      const cart = await res.json();
      render(cart);
    } catch (e) {
      console.error("Cart fetch failed", e);
    }
  }

  function render(cart) {
    countEl.textContent = cart.item_count;
    if (headerCount) headerCount.textContent = cart.item_count;

    if (cart.item_count === 0) {
      emptyEl.style.display = "";
      itemsEl.innerHTML = "";
      footEl.hidden = true;
      return;
    }

    emptyEl.style.display = "none";
    footEl.hidden = false;

    // Upsell: show wash bag unless it's already in the cart
    if (upsellEl) {
      const upVid = parseInt(upsellEl.dataset.upsellVariant, 10);
      const inCart = cart.items.some((i) => i.variant_id === upVid);
      upsellEl.hidden = inCart;
    }

    const discountRow = document.getElementById("cartDrawerDiscountRow");
    const discountAmt = document.getElementById("cartDrawerDiscount");
    const discountTag = document.getElementById("cartDrawerDiscountTag");
    if (cart.total_discount && cart.total_discount > 0) {
      if (discountRow) {
        discountRow.style.display = "flex";
        discountAmt.textContent = "−" + fmt(cart.total_discount);
        const da = cart.items
          .map((i) => (i.line_level_discount_allocations || [])[0])
          .find(Boolean);
        if (discountTag && da && da.discount_application) {
          discountTag.innerHTML =
            TAG_SVG + cleanTag(da.discount_application.title);
        }
      }
    } else if (discountRow) {
      discountRow.style.display = "none";
    }

    subtotalEl.textContent = fmt(cart.total_price);

    itemsEl.innerHTML = cart.items
      .map((item) => {
        const opts = (item.options_with_values || [])
          .filter((o) => o.value && o.value !== "Default Title")
          .map(
            (o) =>
              `<div class="cart-line__opt">${cap(o.name)}: ${o.value}</div>`,
          )
          .join("");
        const saved = item.total_discount > 0;
        const priceHtml = saved
          ? `<div class="cart-line__price"><s>${fmt(item.original_line_price)}</s> ${fmt(item.final_line_price)}</div>
             <div class="cart-line__save">${fmt(item.total_discount)} Savings</div>`
          : `<div class="cart-line__price">${fmt(item.final_line_price)}</div>`;
        const da = (item.line_level_discount_allocations || [])[0];
        // Per-line discount tag is intentionally omitted — it duplicates the
        // "Discounts" tag in the footer; keeping the line compact (fits the 100px card).
        // Lines tied to a bundle/automatic discount are locked — editing happens
        // on the product page so the bundle ratio can't be broken in the cart.
        const locked = !!da;
        const qtyHtml = locked
          ? `<div class="cart-line__qty cart-line__qty--locked"><span>${item.quantity} pair${item.quantity > 1 ? "s" : ""}</span></div>`
          : `<div class="cart-line__qty">
               <button data-qty-dec aria-label="Decrease">−</button>
               <span>${item.quantity}</span>
               <button data-qty-inc aria-label="Increase">+</button>
             </div>`;
        return `
      <div class="cart-line" data-key="${item.key}">
        <div class="cart-line__media">
          ${item.image ? `<img src="${item.image}" alt="${item.product_title}" loading="lazy" />` : ""}
        </div>
        <div class="cart-line__main">
          <div class="cart-line__head">
            <div class="cart-line__title">${item.product_title}</div>
            <button class="cart-line__remove" data-remove aria-label="Remove">${TRASH_SVG}</button>
          </div>
          ${opts}
          <div class="cart-line__row">
            ${qtyHtml}
            <div class="cart-line__prices">${priceHtml}</div>
          </div>
        </div>
      </div>
    `;
      })
      .join("");

    itemsEl.querySelectorAll(".cart-line").forEach((line) => {
      const key = line.getAttribute("data-key");
      const qtyEl = line.querySelector(".cart-line__qty span");
      const dec = line.querySelector("[data-qty-dec]");
      const inc = line.querySelector("[data-qty-inc]");
      const cur = () => parseInt(qtyEl.textContent.replace(/\D/g, ""), 10);
      if (dec)
        dec.addEventListener("click", () => {
          const next = cur() - 1;
          if (next >= 1) qtyEl.textContent = next; // optimistic
          updateQty(key, next, line);
        });
      if (inc)
        inc.addEventListener("click", () => {
          const next = cur() + 1;
          qtyEl.textContent = next; // optimistic
          updateQty(key, next, line);
        });
      line
        .querySelector("[data-remove]")
        .addEventListener("click", () => updateQty(key, 0, line));
    });
  }

  let cartBusy = false;
  async function updateQty(key, qty, line) {
    if (cartBusy) return;
    cartBusy = true;
    if (line) line.classList.add("is-loading");
    try {
      const res = await fetch("/cart/change.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ id: key, quantity: Math.max(0, qty) }),
      });
      const cart = await res.json();
      render(cart);
    } catch (e) {
      console.error(e);
      if (line) line.classList.remove("is-loading");
    }
    cartBusy = false;
  }

  // Upsell add-to-cart
  if (upsellAddBtn && upsellEl) {
    upsellAddBtn.addEventListener("click", async () => {
      upsellAddBtn.disabled = true;
      upsellAddBtn.textContent = "Adding…";
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: parseInt(upsellEl.dataset.upsellVariant, 10),
            quantity: 1,
          }),
        });
        // Апселл — такое же добавление в корзину, как и на карточке товара,
        // и в аналитике должно выглядеть так же.
        try {
          var d = upsellEl.dataset;
          var price = parseFloat(d.upsellPrice);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: "add_to_cart",
            ecommerce: {
              currency: d.currency || "USD",
              value: isNaN(price) ? undefined : price,
              items: [
                {
                  item_id: d.upsellSku || d.upsellVariant,
                  item_name: d.upsellTitle,
                  item_brand: "Velora",
                  price: isNaN(price) ? undefined : price,
                  quantity: 1,
                },
              ],
            },
          });
        } catch (_) {
          /* аналитика не должна ломать покупку */
        }
        await refresh();
      } catch (e) {
        console.error("Upsell add failed", e);
      }
      upsellAddBtn.disabled = false;
      upsellAddBtn.textContent = "Add";
    });
  }

  // Public API
  window.VeloraCart = { open, close, refresh };

  // Sync header count on page load
  fetch("/cart.js")
    .then((r) => r.json())
    .then((cart) => {
      if (headerCount) headerCount.textContent = cart.item_count;
    })
    .catch(() => {});
})();
